<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title>
          {{
            role._id
              ? $t('titles.global.updateModel', { field: $tc('models.role') })
              : $t('titles.global.newModel', { field: $tc('models.role') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn icon dark @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex d-flex xs12 px-2>
            <translation-field
              ref="name"
              v-model="role.name"
              :label="$t('fields.global.name')"
            />
          </v-flex>
          <v-flex d-flex xs12 px-2>
            <translation-field
              ref="description"
              v-model="role.description"
              :label="$t('titles.roles.description')"
            />
          </v-flex>
          <v-flex md4 xs12 px-2>
            <v-autocomplete
              v-model="role.type"
              v-validate="'required'"
              :items="roleTypes"
              :label="
                $t('action.actions.select', {
                  field: $t('fields.global.type'),
                }) + ' (*)'
              "
              :data-vv-name="$t('fields.global.type')"
              :error-messages="errors.collect($t('fields.global.type'))"
            />
          </v-flex>
          <v-flex md8 xs12 px-2>
            <v-autocomplete
              v-model="sortedPermissions"
              :items="permissionSelectList"
              :label="
                $t('action.actions.select', {
                  field: $tc('fields.global.permissions'),
                })
              "
              deletable-chips
              small-chips
              multiple
            />
          </v-flex>
          <v-flex xs12 px-2>
            <v-switch
              v-model="role.active"
              :label="$t('fields.global.active')"
              color="primary"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
        <v-spacer />
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button
          v-if="!role._id"
          type="create"
          :loading="loading"
          @click="submit()"
        />
        <meta-button
          v-else
          type="update"
          :loading="loading"
          @click="submit()"
        />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import TranslationField from '@/components/widgets/Input/TranslationField'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'RoleForm',
  components: {
    TranslationField,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      role: {},
    }
  },
  computed: {
    ...mapState({
      selected: (state) => state.roles.selected,
      loading: (state) => state.roles.loading,
    }),
    ...mapGetters({
      roleTypes: 'roles/roleTypes',
      permissionSelectList: 'roles/permissionSelectList',
    }),
    sortedPermissions: {
      get() {
        if (!this.role.permissions) return []
        return [...this.role.permissions].sort((a, b) =>
          this.permissionSelectList
            .find((p) => p.value == a)
            .text.toLowerCase()
            .localeCompare(
              this.permissionSelectList
                .find((p) => p.value == b)
                .text.toLowerCase()
            )
        )
      },
      set(val) {
        this.selected.permissions = val
      },
    },
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
    selected: {
      handler: function (val) {
        if (val) this.role = parseObject(val)
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.role = parseObject(this.selected)
  },
  methods: {
    ...mapActions({
      setCreate: 'roles/create',
      setUpdate: 'roles/update',
      reset: 'roles/reset',
    }),
    submit() {
      Promise.all([
        this.validate(),
        this.$refs.name.validate(),
        this.$refs.description.validate(),
      ]).then((valid) => {
        if (valid.some((valid) => !valid)) return

        let payload = Object.assign({}, this.role)
        if (!payload._id) {
          this.setCreate(payload).then(() => {
            this.cancel()
          })
        } else {
          this.setUpdate(payload).then(() => {
            this.cancel()
          })
        }
      })
    },
    cancel() {
      this.$emit('close')
      this.clear()
    },
    clear() {
      this.$nextTick(() => {
        this.reset()
        this.$validator.reset()
        if (this.$refs.name) this.$refs.name.$validator.reset()
        if (this.$refs.description) this.$refs.description.$validator.reset()
      })
    },
  },
}
</script>
